import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
	strict: true,
	plugins: [
		createPersistedState()
	],
	state: {
		token: null,
		user: null,
		isUserLoggedIn: false,
		testType: 4,
		attrMinMax: {},
		checkedAttrs: {},
		bubbleCheckedAttrs: [],
		currentClient: {},
		currentGroupClients: [],
		clientsToRemoveFromGroup: {},
		renderClientList: false,
		testAttributes: null,
		groupId: null,
		groupName: null,
		searchResults: []
	},
	mutations: {
		setToken (state, token) {
			state.token = token
			state.isUserLoggedIn = !!(token)
		},
		setUser (state, user) {
			state.user = user
		},
		setTestType (state, testType) {
			state.testType = testType
		},
		setGroupName (state, groupName) {
			state.groupName = groupName
		},
		setTestAttributes (state, testAttributes) {
			state.testAttributes = testAttributes
		},
		setBubbleCheckedAttrs (state, bubbleCheckedAttrs) {
			state.bubbleCheckedAttrs = bubbleCheckedAttrs
		},
		setCheckedAttrs (state, checkedAttrs) {
			state.checkedAttrs = checkedAttrs
		},
		setAttrMinMax (state, attrMinMax) {
			state.attrMinMax = attrMinMax
		},
		setCurrentClient (state, currentClient) {
			state.currentClient = currentClient
		},
		setGroupId (state, groupId) {
			state.groupId = groupId
		},
		setCurrentGroupClients(state, currentGroupClients) {
			state.currentGroupClients = currentGroupClients
		},
		setClientsToRemoveFromGroup(state, clientsToRemoveFromGroup) {
			state.clientsToRemoveFromGroup = clientsToRemoveFromGroup
		},
		setRenderClientList(state, renderClientList) {
			state.renderClientList = renderClientList
		},
		setSearchResults (state, searchResults) {
			state.setSearchResults = searchResults
		},
	},
	actions: {
		async setToken ({commit}, token) {
			commit('setToken', token)
		},
		async setUser ({commit}, user) {
			commit('setUser', user)
		},
		async setTestType ({commit}, testType) {
			commit('setTestType', testType)
		},
		async setGroupName ({commit}, groupName) {
			commit('setGroupName', groupName)
		},
		async setTestAttributes ({commit}, testAttributes) {
			commit('setTestAttributes', testAttributes)
		},
		async setBubbleCheckedAttrs ({commit}, bubbleCheckedAttrs) {
			commit('setBubbleCheckedAttrs', bubbleCheckedAttrs)
		},
		async setCheckedAttrs ({commit}, checkedAttrs) {
			commit('setCheckedAttrs', checkedAttrs)
		},		
		async setAttrMinMax ({commit}, attrMinMax) {
			commit('setAttrMinMax', attrMinMax)
		},
		async setCurrentClient ({commit}, currentClient) {
			commit('setCurrentClient', currentClient)
		},
		async setCurrentGroupClients ({commit}, currentGroupClients) {
			commit('setCurrentGroupClients', currentGroupClients)
		},
		async setSearchResults ({commit}, searchResults) {
			commit('setSearchResults', searchResults)
		},
		async setGroupId ({commit}, groupId) {
			commit('setGroupId', groupId)
		},
		async setClientsToRemoveFromGroup ({commit}, clientsToRemoveFromGroup) {
			commit('setClientsToRemoveFromGroup', clientsToRemoveFromGroup)
		},
		async setRenderClientList ({commit}, renderClientList) {
			commit('setRenderClientList', renderClientList)
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/store.js